import type { FC } from "react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import Link from "next/link";
import { BASE_PATH } from "@/lib/base-path";
import { navigatorLine } from "@/lib/contact";
import { routes } from "@/lib/routes";

export const UTILITY_BAR_COOKIE = "utility_bar_dismissed";

export const rememberUtilityBarDismissed = () => {
  document.cookie = `${UTILITY_BAR_COOKIE}=1; path=${BASE_PATH || "/"}; samesite=lax`;
};

type UtilityBarProps = {
  onDismiss: () => void;
};

/** The aqua top strip — a crisis-support line, so it only disappears when the visitor dismisses it. */
export const UtilityBar: FC<UtilityBarProps> = ({ onDismiss }) => (
  <div className="bg-tone-aqua-tint px-16 py-12 lg:px-46 lg:py-16">
    <div className="page-width flex items-start gap-10">
      <p className="flex-1 text-14 leading-[1.4] text-neutral-black lg:text-center">
        Need help finding the right support? Contact our Mental Health Navigator for guidance, information, and
        referrals to appropriate services. We are not a clinic and do not provide counselling or treatment. Talk to
        someone now. Call our Navigator on{" "}
        <a href={navigatorLine.tel} className="font-medium hover:underline">
          {navigatorLine.display}
        </a>{" "}
        {navigatorLine.hours} or{" "}
        <Link href={routes.urgentHelp.url} target="_blank" rel="noreferrer" className="font-medium underline">
          Click here for urgent help.
        </Link>
      </p>
      <button type="button" onClick={onDismiss} aria-label="Dismiss">
        <XMarkIcon aria-hidden className="size-20 shrink-0 cursor-pointer text-neutral-black" />
      </button>
    </div>
  </div>
);
